import { render, staticRenderFns } from "./masterDetailsRenderer.vue?vue&type=template&id=6981db1a&scoped=true&"
import script from "./masterDetailsRenderer.vue?vue&type=script&lang=js&"
export * from "./masterDetailsRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6981db1a",
  null
  
)

export default component.exports